$(document).ready(function () {
    $(document).on("click", "#faq_accordion .card", function () {
        if (!!$(this).attr("data-open") === false) {
            $("#faq_accordion .card").removeAttr("data-open");
            $(this).attr("data-open", true);
        } else {
            $(this).removeAttr("data-open");
        }
    });
});